import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Gift, ArrowRight, X } from "lucide-react";
import AuthModal from "@/components/auth/AuthModal";
import { useAuth } from "@/contexts/AuthContext";

const NewCustomerBanner = () => {
  const { user } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Don't show if user is logged in or banner is dismissed
  if (user || dismissed) {
    return null;
  }

  return (
    <>
      <section className="mt-20 pt-4 relative overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="relative bg-gradient-to-r from-primary/20 via-primary/10 to-primary/20 border border-primary/30 rounded-xl py-3 px-4 max-w-2xl mx-auto">
            {/* Dismiss button */}
            <button
              onClick={() => setDismissed(true)}
              className="absolute top-2 right-2 p-1 text-muted-foreground hover:text-foreground transition-colors z-10"
              aria-label="Sluiten"
            >
              <X className="w-4 h-4" />
            </button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pr-6">
              {/* Icon - hidden on mobile */}
              <div className="hidden sm:flex w-10 h-10 rounded-full bg-primary/20 items-center justify-center flex-shrink-0">
                <Gift className="w-5 h-5 text-primary" />
              </div>

              {/* Content */}
              <p className="text-sm text-foreground text-center sm:text-left">
                <span className="font-semibold">Nieuw hier?</span> Ontvang{" "}
                <span className="text-primary font-semibold">10% korting</span> op je eerste bestelling!
              </p>

              {/* Button */}
              <Button 
                variant="glow" 
                size="sm"
                onClick={() => setShowAuthModal(true)}
                className="group whitespace-nowrap"
              >
                Account aanmaken
                <ArrowRight className="w-3 h-3 ml-1 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)}
        defaultView="register"
      />
    </>
  );
};

export default NewCustomerBanner;
